export default "__VITE_ASSET__DbiLrINT__"